import { createReducer, on } from "@ngrx/store";
import { Deal } from "../../shared/models/deal.model";
import { DefaultGenericList, GenericList } from "../shared/models/generic-list.model";
import {
  clearPortfolios,
  loadPortfolioDetails,
  loadPortfolioDetailsFail,
  loadPortfolios,
  loadPortfolioDetailsSuccess,
  loadPortfoliosFail,
  loadPortfoliosSuccess
} from "./portfolios.actions";

export interface PortfoliosState {
  initialized?: boolean;
  loading?: boolean;
  list?: GenericList<Deal>;
  total?: number;
  totalPages?: number;
  entities?: {[code: string]: Deal};
}

const initialState: PortfoliosState = {
  initialized: false,
  loading: false,
  list: DefaultGenericList<Deal>(),
  total: 0,
  totalPages: 0,
  entities: {}
};

export const portfoliosReducer = createReducer(
  initialState,

  on(loadPortfolios, (state) => ({
    ...state,
    loading: true
  })),
  on(loadPortfoliosFail, (state) => ({
    ...state,
    initialized: true,
    loading: false,
  })),
  on(loadPortfoliosSuccess, (state, action) => ({
    ...state,
    initialized: true,
    loading: false,
    total: action.payload.total,
    totalPages: action.payload.totalPages ?? 0,
    list: {
      ...state.list,
      items: action.payload.portfolios
    }
  })),

  on(loadPortfolioDetails, (state) => ({ ...state, loading: true })),
  on(loadPortfolioDetailsFail, (state) => ({ ...state })),
  on(loadPortfolioDetailsSuccess, (state, action) => ({
    ...state,
    loading: false,
    entities: {
      ...state.entities,
      [action.payload.portfolio.code]: action.payload.portfolio
    }
  })),

  on(clearPortfolios, () => initialState)
);
